<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import useUser from '../../../../Composables/User/useUser.ts'
import ServiceToggleButton from './ServiceToggleButton.vue'

export default {
  components: { ServiceToggleButton },
  mixins: [mixinComponent, globalVariablesMixin],
  props: {
    def: { type: Object, default: {} },
    services: { type: Array },
    duration: { type: Number, required: true },
    displayTtc: { type: Boolean, default: false },
    isSigned: { type: Boolean, default: false },
    equipment: { type: Object, required: true },
    finance: { type: Object, required: true },
    loading: { type: Map, required: false, default: new Map() },
    readonly: { type: Boolean, required: false, default: false },
  },
  setup() {
    const { isReadOnly } = useUser()

    return {
      isReadOnly,
    }
  },
  computed: {
    isServiceEditionDisabled() {
      return this.isReadOnly || this.isSigned || this.readonly
    },
    availableServiceTypes() {
      return this.def.finance.serviceTypes.options.choices
        .filter(({ serviceCategory }) => !serviceCategory.hidden)
        .sort((a, b) => {
          //ascending +/- pour descending -/+
          return (
            (a.displayOrder === null) - (b.displayOrder === null) ||
            +(a.displayOrder > b.displayOrder) ||
            -(a.displayOrder < b.displayOrder)
          )
        })
    },
    singleEquipment() {
      return this.equipment.equipments.length === 0
    },
    atLeastOneServiceEditable() {
      return this.availableServiceTypes.some(({ editable }) => editable)
    },
    readonlyServices() {
      const readonlyServices = []
      for (const service of this.services) {
        if (!service.active) {
          continue
        }

        const serviceType = service.serviceType
        const serviceCategory = serviceType?.serviceCategory
        if (serviceType?.editable || !serviceType?.unique || !serviceType?.exclusive) {
          continue
        }

        if (!serviceCategory?.hidden) {
          readonlyServices.push(service)
        }
      }

      return readonlyServices
    },
  },
  methods: {
    serviceFormClick(id) {
      this.$refs[id][0].showForm()
    },
    serviceActive(json) {
      for (const [index, serviceType] of Object.entries(this.def.finance.serviceTypes.options.choices)) {
        if (serviceType && json.serviceType && serviceType.id === json.serviceType.id) {
          serviceType['active'] = json.active
          serviceType['serviceId'] = json.id
        }
      }
      this.setValue(this.def, 0, this.def)
    },
    servicesSent(s) {
      this.$emit('services-sent', s.json)
      this.setServiceAmount(s.json)
      s.json.serviceType['serviceId'] = s.json.id
      if (s.json.active) {
        s.json.serviceType['active'] = s.json.active
      }
      if (s.json.amountDurations) {
        s.json.serviceType['amountDurations'] = s.json.amountDurations
      }
      s.json.serviceType['includeToRent'] = s.json.includeToRent
      s.json.serviceType['level'] = s.json.level
      const indexService = this.def.finance.serviceTypes.options.choices.findIndex(
        (obj) => obj.id === s.json.serviceType.id,
      )
      this.setValue(this.services, indexService, s.json)
      const index = this.def.finance.serviceTypes.options.choices.findIndex((obj) => obj.id === s.json.serviceType.id)
      this.setValue(this.def.finance.serviceTypes.options.choices, index, s.json.serviceType)
    },
    getPack(serviceTypeId) {
      let pack = ''
      this.services.forEach((service, index) => {
        if (service.serviceType.id == serviceTypeId) {
          if (service.others && service.others.pack && service.others.pack.value) {
            pack = service.others.pack.value
          }
        }
      })
      return ' ' + pack
    },
    getAmount(service, formatted = true) {
      if (service.amountDurations && (service.amountDurations[this.duration] || service.amountDurations[0])) {
        var amounts = service.amountDurations[this.duration]
        if (!amounts) {
          amounts = service.amountDurations[0]
        }
        if (this.displayTtc && amounts.amountVat) {
          return formatted ? this.$n(Number(amounts.amountVat), 'currency') : amounts.amountVat
        } else if (amounts.amount) {
          return formatted ? this.$n(Number(amounts.amount), 'currency') : amounts.amount
        }
      }
    },
    toggleService(serviceType) {
      let active = true
      if (this.isServiceEditionDisabled) {
        return
      }

      //si click 2nd fois unset active
      if (serviceType.active) {
        active = false
        // on vérifie que ce n'est pas le dernier si category mandatory
        if (serviceType.serviceCategory.mandatory && !this.hasRole('ROLE_SUPER_USER')) {
          const category = serviceType.serviceCategory.id
          let count = 0
          for (const [key2, other] of Object.entries(this.def.finance.serviceTypes.options.choices)) {
            if (other.serviceCategory.id === category) {
              if (other.active) {
                count++
              }
            }
          }

          //Si il y'en n'a qu'un, alors on ne décoche pas.
          if (count === 1) {
            active = true
          }
        }
      }

      this.setValue(serviceType, 'active', active)

      let serviceTypes = []
      for (let i = 0; i < this.def.finance.serviceTypes.options.choices.length; i++) {
        if (this.def.finance.serviceTypes.options.choices[i].active === true) {
          serviceTypes.push(this.def.finance.serviceTypes.options.choices[i].id)
        }
      }

      return this.$emit('toggle-sent', serviceTypes, serviceType, active)
    },
    initServices() {
      if (this.def.finance.serviceTypes.options.choices) {
        let level = false
        for (const [key2, service] of Object.entries(this.services)) {
          this.setServiceAmount(service)
          if (service.level) {
            level = true
            this.$emit('has-service-level')
          }
        }
        for (let i = 0; i < this.def.finance.serviceTypes.options.choices.length; i++) {
          this.setValue(this.def.finance.serviceTypes.options.choices[i], 'level', level)
        }
      }
    },
    setServiceAmount(service) {
      for (const [key, serviceType] of Object.entries(this.def.finance.serviceTypes.options.choices)) {
        if (service.serviceType.id === serviceType.id) {
          this.setValue(this.def.finance.serviceTypes.options.choices[key], 'serviceId', service.id)
          this.setValue(this.def.finance.serviceTypes.options.choices[key], 'includeToRent', service.includeToRent)
          if (service.active === true) {
            this.setValue(this.def.finance.serviceTypes.options.choices[key], 'active', true)
          }
        }
      }
    },
    serviceButtonClasses(serviceType) {
      return {
        btn: true,
        'btn-primary': serviceType.active,
        'btn-toggle': !serviceType.active,
        disabled: this.isServiceEditionDisabled,
      }
    },
    includeServiceAtMostOnce(serviceType) {
      return this.getServicesByServiceType(serviceType).length <= 1
    },
    getServicesByServiceType({ id: serviceTypeId }) {
      return this.finance.services.filter(({ serviceType }) => serviceType.id === serviceTypeId)
    },
    isServiceTypeActive({ id: serviceTypeId }) {
      const serviceType = this.def.finance.serviceTypes.options.choices.find(
        (serviceType) => serviceType.id === serviceTypeId,
      )
      if (!serviceType) {
        return false
      }

      return serviceType.active
    },
    isEditable(serviceType) {
      return (
        !user.isReadOnly && serviceType.editable && this.includeServiceAtMostOnce(serviceType) && this.singleEquipment
      )
    },
  },

  beforeMount() {
    this.initServices()
  },
  watch: {
    def(newVal, oldVal) {
      // watch it
      this.initServices()
    },
  },
}
</script>
<template>
  <div id="service" role="toolbar">
    <div class="d-flex justify-content-end">
      <ServiceToggleButton
        v-for="serviceType in availableServiceTypes"
        :key="serviceType.id"
        :editable="isEditable(serviceType)"
        :active="serviceType.active"
        :disabled="isServiceEditionDisabled"
        :loading="loading.has(serviceType.id)"
        :service-type="serviceType"
        :services="getServicesByServiceType(serviceType)"
        :tax-included="displayTtc"
        :duration="duration"
        class="ml-2"
        @edit="$emit('edit', serviceType)"
        @toggle="toggleService(serviceType)"
      />
      <ServiceToggleButton
        v-for="service in readonlyServices"
        :key="service.id"
        :service-type="service.serviceType"
        :services="[service]"
        :tax-included="displayTtc"
        :duration="duration"
        class="ml-2"
        active
      />
    </div>
    <div v-if="atLeastOneServiceEditable && !singleEquipment" class="text-right">
      <small>{{ $t('service.help.editService') }}</small>
    </div>
  </div>
</template>
